export default __webpack_public_path__ + "static/media/Resources.cab8b35e.svg";